import axios from 'axios'
import { ApiResponse, Comment } from '@/types'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

// 建立 axios 實例
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

// 請求攔截器 - 添加認證 token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 回應攔截器 - 處理錯誤
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token 過期或無效，清除本地存儲並重新導向到登入頁
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export interface CreateCommentData {
  content: string
  issueId: string
}

export interface UpdateCommentData {
  content: string
}

// 取得議題的所有留言
export const getComments = async (issueId: string): Promise<ApiResponse<{ comments: Comment[] }>> => {
  const response = await api.get(`/comments/${issueId}`)
  return response.data
}

// 新增留言
export const createComment = async (data: CreateCommentData): Promise<ApiResponse<{ comment: Comment }>> => {
  const response = await api.post('/comments', data)
  return response.data
}

// 更新留言
export const updateComment = async (commentId: string, data: UpdateCommentData): Promise<ApiResponse<{ comment: Comment }>> => {
  const response = await api.put(`/comments/${commentId}`, data)
  return response.data
}

// 刪除留言
export const deleteComment = async (commentId: string): Promise<ApiResponse> => {
  const response = await api.delete(`/comments/${commentId}`)
  return response.data
}